import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SiteFooter } from "@/components/layout/site-footer";
import { SiteHeader } from "@/components/layout/site-header";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
  /** Hide the footer (useful for special pages like login) */
  hideFooter?: boolean;
  /** Hide the header (useful for special pages) */
  hideHeader?: boolean;
  /** Active page for header navigation highlighting */
  activePage?: 'home' | 'for-restaurants' | 'solutions' | 'integrations' | 'blog';
}

/**
 * Root page layout wrapper.
 * Provides the outermost container for a page with proper width constraints.
 * Includes the site header and footer by default.
 *
 * Structure: PageLayout > SiteHeader + Main Content + Footer
 */
export function PageLayout({
  children,
  className,
  hideFooter = false,
  hideHeader = false,
  activePage,
}: PageLayoutProps) {
  return (
    <div
      className={cn(
        "flex min-h-screen flex-col w-full",
        className
      )}
    >
      {!hideHeader && <SiteHeader activePage={activePage} />}
      {children}
      {!hideFooter && <SiteFooter />}
    </div>
  );
}
